import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useSuspenseVendedoresUnidadeNegocio } from '@/features/proposta/hooks'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
import { CardEtapaInicial } from '@/pages/proposta/etapa-informacoes-iniciais/card-etapa-inicial'
import { ComboboxField } from '@/shared/components/ui/combobox'

export const CardVendedorResponsavel = () => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<TPropostaSchemaInput>()
  const { t } = useTranslation('proposta')

  const vendedorSelecionadoId = watch('informacoesIniciais.vendedor.id')
  const variant = vendedorSelecionadoId && !errors.informacoesIniciais?.vendedor?.message ? 'completed' : 'default'
  const vendedorAlocadoId = watch('informacoesIniciais.vendedorAlocadoCliente')
  const { data: vendedores } = useSuspenseVendedoresUnidadeNegocio()

  useEffect(() => {
    if (vendedorAlocadoId) {
      const vendedorAlocadoNaListaVendedores = vendedores.find((vendedor) => vendedor.id === vendedorAlocadoId)

      if (!vendedorSelecionadoId && vendedorAlocadoNaListaVendedores?.id) {
        const vendedorAlocado = {
          id: vendedorAlocadoNaListaVendedores.id,
          possuiDadosDeComissao: vendedorAlocadoNaListaVendedores.possuiDadosDeComissao,
        }
        setValue('informacoesIniciais.vendedor', vendedorAlocado, { shouldValidate: true })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <CardEtapaInicial variant={variant}>
      <CardEtapaInicial.Content
        label={t('informacoes_iniciais.cards.vendedor.titulo')}
        description={t('informacoes_iniciais.cards.vendedor.selecione')}
      />
      <CardEtapaInicial.Action>
        <ComboboxField
          data-testid="selecao-vendedor"
          name="informacoesIniciais.vendedor"
          control={control}
          valueMode="object"
          labelProperty="nome"
          valueProperty="id"
          objectProperties={['id', 'possuiDadosDeComissao']}
          placeholder={t('informacoes_iniciais.cards.selecione')}
          options={vendedores}
          hideClearButton={false}
          initialValue={{ id: '', possuiDadosDeComissao: false }}
        />
      </CardEtapaInicial.Action>
    </CardEtapaInicial>
  )
}
